// extracted by mini-css-extract-plugin
module.exports = {"title":"Documents_title__3Dsgl","selects":"Documents_selects__xOIkY"};